import { c as _c } from "react/compiler-runtime";
interface MapPinIconProps {
  size?: number;
  className?: string;
}
const MapPinIcon = t0 => {
  const $ = _c(6);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  const t2 = `dynamic-size ${className}`;
  let t3;
  if ($[0] !== size) {
    t3 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = t3 as React.CSSProperties;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <path d="M7.73333 7.82C8.02978 7.82 8.28311 7.71444 8.49333 7.50333C8.70356 7.29222 8.80844 7.03822 8.808 6.74133C8.80756 6.44444 8.70178 6.19111 8.49067 5.98133C8.27956 5.77156 8.02556 5.66667 7.72867 5.66667C7.43178 5.66667 7.17844 5.77244 6.96867 5.984C6.75889 6.19556 6.654 6.44956 6.654 6.746C6.654 7.04244 6.75956 7.29578 6.97067 7.506C7.18178 7.71622 7.436 7.82044 7.73333 7.82ZM7.73067 14.0127C6.164 12.6273 4.984 11.3353 4.19067 10.1367C3.39689 8.938 3 7.84711 3 6.864C3 5.45378 3.45911 4.29067 4.37733 3.37467C5.296 2.45822 6.41378 2 7.73067 2C9.04756 2 10.1653 2.45822 11.084 3.37467C12.0022 4.29067 12.4613 5.45378 12.4613 6.864C12.4613 7.84711 12.0647 8.938 11.2713 10.1367C10.4776 11.3353 9.29733 12.6273 7.73067 14.0127Z" fill="currentColor" />;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t2 || $[4] !== t4) {
    t6 = <svg className={t2} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style={t4}>{t5}</svg>;
    $[3] = t2;
    $[4] = t4;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  return t6;
};
export default MapPinIcon;